import i18n from 'i18next'
import k from './../../i18n/keys'
import React, { useEffect, useState } from 'react'
import Letter64 from '@evocolabs/icons/lib/Letter64'
import { Typography } from '@evocolabs/orkaui'
import { useRouter } from 'next/router'

const defaultWord = 'Resend Email'
const successWord = i18n.t(k.EMAIL_SENT)
const failWord = 'Please Try Again Later'

const VerifyEmail = ({
  type,
  signUpEmail,
  logInEmail,
  setSignUpEmail,
  showLink = true,
  prompt = ''
}) => {
  const email = type === 'initial' ? signUpEmail : logInEmail
  const [sendEmail, setSendEmail] = useState('default')
  const router = useRouter()
  const handleClick = async () => {
    setSignUpEmail('')
    router.push('/SignIn/CreateAccount')
  }
  const [currentContent, setCurrentContent] = useState(defaultWord)

  useEffect(() => {
    if (sendEmail === 'success') {
      setCurrentContent(successWord)
    } else if (sendEmail === 'default') {
      setCurrentContent(defaultWord)
    } else {
      setCurrentContent(failWord)
    }
  }, [sendEmail])

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '32px',
        alignItems: 'center'
      }}
    >
      <Typography variant="h4">
        {type === i18n.t(k.INITIAL)
          ? 'Check your email'
          : type === i18n.t(k.FIREBASE)
          ? i18n.t(k.WE_HAVE_UPDATED_LOGIN_SYSTEM)
          : i18n.t(k.ACCOUNT_NEEDED_TO_BE_VERIFIED)}
      </Typography>
      <div>
        <Letter64 />
      </div>
      <Typography variant="body2" textAlign="center">
        {prompt || `We just sent a link to activate your Orka account`}{' '}
        <Typography variant="Body2" textAlign="center">
          {email}
        </Typography>
      </Typography>
      <div style={{ display: showLink ? 'block' : 'none' }}>
        <Typography onClick={handleClick} variant="Link">
          I didn’t receive the link
        </Typography>
      </div>
    </div>
  )
}

export default VerifyEmail
